// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

const styles = css`
  .banner-wrapper {
    padding-left: 20px;
    display: flex;
  }
  .triangle-left {
    width: 0;
    height: 0;
    border-top: 10px solid transparent;
    border-right: 20px solid ${(props) => props.theme.colorPalette.yellow[500]};
    border-bottom: 10px solid transparent;
  }
  .triangle-top {
    margin-left: 5px;
    position: absolute;
    top: 29px;
    left: 82px;
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    border-bottom: 7px solid ${(props) => props.theme.colorPalette.yellow[500]};

    @media ${(props) => props.theme.mediaQuery.medium} {
      width: 0;
      height: 0;
      position: inherit;
      border-top: 10px solid transparent;
      border-right: 20px solid ${(props) => props.theme.colorPalette.yellow[500]};
      border-bottom: 10px solid transparent;
      margin-left: 0;
      border-left: 0;
    }
  }

  .promo-wrapper {
    display: flex;
    padding-right: 10px;
    align-items: center;
    background-color: ${(props) => props.theme.colorPalette.yellow[500]};
  }
  .off-label {
    display: inline;
    padding-left: 5px;
  }
  .richtextCss {
    margin-top: -2px;
    margin-left: 3px;
  }

  .fullBleedBanner {
    text-align: center;

    .banner {
      background-color: ${(props) => props.theme.colorPalette.yellow[500]};
      width: 100%;
      margin: 0;
      border-radius: 6px;
      ${(props) =>
        props.isAddedToBagRedesign &&
        `
          background-color: ${props.theme.colorPalette.yellow[500]};
          border-radius: 7px;
          border-bottom-left-radius: 0;
          border-bottom-right-radius: 0;
          `}
    }
    .is-added-to-bag-redesign {
      ${(props) =>
        props.isAddedToBagRedesign &&
        `
          font-weight: ${props.theme.fonts.fontWeight.black};
          font-family: ${props.theme.fonts.secondaryFontFamily};
          font-size: ${props.theme.typography.fontSizes.fs13};
          `}
    }
    .pickUp {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .addedtobag-bossbanner {
      line-height: 2.9;
      ${(props) =>
        props.isAddedToBagRedesign &&
        `
        line-height: 2.3;
      `}
    }
  }

  .triangle-top + .promo-wrapper {
    width: 100%;
    max-width: 150px;
    min-height: 20px;

    .richtextCss {
      margin-right: auto;
      margin-left: auto;

      @media ${(props) => props.theme.mediaQuery.medium} {
        margin-left: 3px;
      }
    }
  }
`;

export default styles;
